<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2025-01-06 14:12:07
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2025-01-13 18:10:48
 * @FilePath: src/views/sub-app/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<template>
  <div class="sub-app-container">
    <left-aside
      style="width: 220px"
      v-if="sideMenuList.length > 0"
    ></left-aside>
    <div
      :class="
        sideMenuList.length > 0
          ? scope.clsPrefix
          : scope.clsPrefix + ' noLeftAside'
      "
    >
      <div v-if="sideMenuList.length > 0" class="sub-app-container-header">
        <div :class="scope.clsPrefix + '_pageTagList'">
          <div
            :class="
              '/' + $route.meta.context + '/' + item.url ==
              appPath.split('?')[0]
                ? `${scope.clsPrefix}_pageTag active`
                : scope.clsPrefix + '_pageTag'
            "
            v-for="(item, index) in openedPage[appMenu && appMenu[0].appId]"
            :key="index"
            @click="goPage(item)"
          >
            {{ item.name }}
            <i
              v-if="item.url != firstMenu.url"
              :class="`el-icon-close ${scope.clsPrefix}_pageTag_close`"
              @click.stop="cancelOpenedPage(item)"
            ></i>
          </div>
        </div>
        <el-dropdown :class="scope.clsPrefix + '_tagBtn'">
          <div>
            <img src="@/assets/imgs/tagBtn.png" alt="" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="closeTag('left')"
              >关闭左侧</el-dropdown-item
            >
            <el-dropdown-item @click.native="closeTag('right')"
              >关闭右侧</el-dropdown-item
            >
            <el-dropdown-item @click.native="closeTag('all')"
              >关闭全部</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        :class="
          sideMenuList.length > 0
            ? 'sub-app-container-micro'
            : 'sub-app-container-micro empty'
        "
      >
        <micro-app
          :key="name"
          :name="name"
          :url="url"
          keep-alive
          :inline="inline === 1"
          default-page="/"
          :iframe="sandbox == 'iframe'"
          :baseroute="`/${name}`"
          v-loading="loading"
          allow="microphone; camera; midi; encrypted-media"
          @created="created"
          @beforemount="beforemount"
          @beforeshow="beforemount"
          @mounted="mounted"
          @unmount="unmount"
          @afterhidden="unmount"
          @aftershow="mounted"
          @error="error"
          @datachange="handleDataChange"
          style="height: 100%; overflow: auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import microApp from '@micro-zoe/micro-app'
import LeftAside from '@/views/index/left-aside/sub-app-aside.vue'
import Cookies from 'js-cookie'
import { findFirstRoute } from '@/store/utils/route'
import { mapState } from 'vuex'
// 配置文件
// import config from "@/config/index.js";
export default {
  // 组件名称
  name: 'SubApp',
  components: {
    LeftAside
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'sub-app'
      },
      appPath: '',
      // 加载
      loading: true,
      faviconUrl: '', // 新增faviconUrl
      tabTitle: '' // 新增tabTitle
    }
  },
  // 计算属性
  computed: {
    ...mapState('app', ['appMenu', 'appDepthMenu']),
    ...mapState('user', ['userInfo', 'sysConfig', 'skin']),
    ...mapState('permission', ['openedPage']),
    // 当前路由
    currentRoute() {
      return this.$route
    },
    matchedItem() {
      return this.findMenuItemByUrl(this.appMenu, this.appPath.split('?')[0])
    },
    // 路由信息
    routeMeta() {
      return this.currentRoute?.meta || {}
    },
    // 应用地址
    url() {
      return this.currentRoute.meta.url || ''
    },
    // 名称
    name() {
      return this.routeMeta.context || ''
    },
    // 沙箱
    sandbox() {
      return this.routeMeta.sandbox || 'with'
    },
    inline() {
      return this.routeMeta.inline || 0
    },
    firstMenu() {
      return findFirstRoute(this.appMenu)
    },
    // // 传递给子集数据
    // dataForChild() {
    //   return {
    //     // 来源是超级应用
    //     origin: 'EIIP',
    //     skin: this.skin,
    //     clientId: this.routeMeta.id,
    //     refreshTokenCookieName: this.sysConfig.refreshTokenCookieName,
    //     accessTokenCookieName: this.sysConfig.accessTokenCookieName,
    //     accessToken: Cookies.get(this.sysConfig.accessTokenCookieName),
    //     refreshToken: Cookies.get(this.sysConfig.refreshTokenCookieName),
    //     eiipToken: Cookies.get(this.sysConfig.accessTokenCookieName),
    //     userInfo: this.userInfo,
    //     appUrl: this.url
    //   }
    // },
    sideMenuList() {
      return this.appMenu
    }
  },
  watch: {
    appPath: {
      // immediate: true,
      handler(newVal) {
        const matchedItem = this.findMenuItemByUrl(
          this.appMenu,
          newVal.split('?')[0]
        )
        if (matchedItem) {
          this.$store.commit('permission/ADD_OPENED_PAGE', matchedItem)
        }
        // 确保active标签在视图中
        this.$nextTick(() => {
          this.scrollToActiveTag()
        })
      }
    }
  },
  // 创建完成
  created() {
    this.loading = true
  },
  // 挂载完成
  mounted() {
    microApp.router.beforeEach((to, from, appName) => {
      this.appPath = to.fullPath
    })
    // 监听来自子应用my-app的数据
    microApp.addDataListener(this.name, this.dataListener)
    // 主应用定时检查并恢复title
    setInterval(() => {
      if (
        this.$store.state.config.clientEndTitle &&
        document.title != this.$store.state.config.clientEndTitle
      ) {
        document.title = this.$store.state.config.clientEndTitle
      }
    }, 1000)
  },

  // 卸载
  destroyed() {
    console.log('页面卸载')
    // 解绑监听my-app子应用的函数
    microApp.removeDataListener(this.name, this.dataListener)
    microApp.clearData(this.name)
    // microApp.unmountAllApps().then(() => console.log('卸载成功'))
  },
  // 方法
  methods: {
    // 滚动到active标签
    scrollToActiveTag() {
      this.$nextTick(() => {
        const activeTag = document.querySelector(
          `.${this.scope.clsPrefix}_pageTag.active`
        )
        const tagList = document.querySelector(
          `.${this.scope.clsPrefix}_pageTagList`
        )
        if (activeTag && tagList) {
          const tagLeft = activeTag.offsetLeft
          const tagWidth = activeTag.offsetWidth
          const containerWidth = tagList.offsetWidth
          const scrollLeft = tagList.scrollLeft
          // 如果active标签在视图右侧不可见
          if (tagLeft + tagWidth > scrollLeft + containerWidth) {
            tagList.scrollLeft = tagLeft + tagWidth - containerWidth + 20
          } else if (tagLeft < scrollLeft) {
            // 如果active标签在视图左侧不可见
            tagList.scrollLeft = tagLeft - 20
          }
        }
      })
    },
    closeTag(type) {
      const index = this.openedPage[this.matchedItem.appId].findIndex(
        (page) => page.url === this.matchedItem.url
      )
      const appId = this.matchedItem.appId
      switch (type) {
        case 'left':
          if (index > 1) {
            // 优化: 直接使用slice截取右侧部分，包括当前标签，并保留第一个标签
            this.$nextTick(() => {
              this.$store.state.permission.openedPage[appId] =
                this.$store.state.permission.openedPage[appId]
                  .slice(0, 1)
                  .concat(
                    this.$store.state.permission.openedPage[appId].slice(index)
                  )
            })
            sessionStorage.setItem(
              'openedPage',
              JSON.stringify(this.$store.state.permission.openedPage)
            )
          } else {
            this.$message.warning('左侧已无可关闭标签！')
          }
          break
        case 'right':
          if (
            index !==
            this.$store.state.permission.openedPage[appId].length - 1
          ) {
            // 添加关闭右侧标签逻辑: 保留左侧部分，包括当前标签
            this.$nextTick(() => {
              this.$store.state.permission.openedPage[appId] =
                this.$store.state.permission.openedPage[appId].slice(
                  0,
                  index + 1
                )
            })
            sessionStorage.setItem(
              'openedPage',
              JSON.stringify(this.$store.state.permission.openedPage)
            )
          } else {
            this.$message.warning('当前标签已经是最后一个标签')
          }
          break
        case 'all':
          if (this.$store.state.permission.openedPage[appId].length > 1) {
            // 添加关闭全部标签逻辑: 只保留第一个标签
            this.$nextTick(() => {
              this.$store.state.permission.openedPage[appId] =
                this.$store.state.permission.openedPage[appId].slice(0, 1)
              sessionStorage.setItem(
                'openedPage',
                JSON.stringify(this.$store.state.permission.openedPage)
              )
            })
            microApp.router.push({
              name: this.$route.meta.context,
              path: `/${this.$route.meta.context}/${this.firstMenu.url}`,
              replace: true
            })
          } else {
            this.$message.warning('暂无可关闭标签')
          }
          break
      }
    },
    goPage(item) {
      microApp.router.push({
        name: this.$route.meta.context,
        path: `/${this.$route.meta.context}/` + item.url,
        replace: true
      })

      // 页面跳转后确保active标签在视图中
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToActiveTag()
        }, 100)
      })
    },
    cancelOpenedPage(item) {
      const url = item.url
      if (this.appPath.split('?')[0] == `/${this.$route.meta.context}/${url}`) {
        const index = this.openedPage[item.appId].findIndex(
          (page) => page.url === url
        )
        if (index > 0) {
          microApp.router.push({
            name: this.$route.meta.context,
            path: `/${this.$route.meta.context}/${
              this.openedPage[item.appId][index - 1].url
            }`,
            replace: true
          })
        } else if (index == 0) {
          microApp.router.push({
            name: this.$route.meta.context,
            path: `/${this.$route.meta.context}/${this.firstMenu.url}`,
            replace: true
          })
        }
      }
      this.$nextTick(() => {
        this.$store.dispatch('permission/cancelOpenedPage', item)
        console.log(this.openedPage)
      })
    },
    findMenuItemByUrl(menuList, targetUrl) {
      for (const item of menuList) {
        if (item.children && Array.isArray(item.children)) {
          const result = this.findMenuItemByUrl(item.children, targetUrl)
          if (result) {
            return result
          }
        }
        if (
          '/' + this.$route.meta.context + '/' + item.url === targetUrl &&
          item.type != 'BUTTON'
        ) {
          return item
        }
      }
      return undefined
    },
    /**
     * 创建完成
     * @returns {void}
     */
    created() {
      this.loading = true
      console.log(this.name, 'created')
    },
    async dataListener(data) {
      if (data.loginStatus == 401) {
        this.$store.dispatch('user/resetToken').then(() => {
          this.$message.warning('登录状态过期,2s后自动刷新页面！')
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        })
      }
    },
    /**
     * 子应用加载之前
     * @returns {void}
     */
    beforemount() {
      console.log(this.name, 'beforemount')
      microApp.setData(this.name, {
        origin: 'EIIP',
        skin: this.skin,
        clientId: this.routeMeta.id,
        refreshTokenCookieName: this.sysConfig.refreshTokenCookieName,
        accessTokenCookieName: this.sysConfig.accessTokenCookieName,
        accessToken: Cookies.get(this.sysConfig.accessTokenCookieName),
        refreshToken: Cookies.get(this.sysConfig.refreshTokenCookieName),
        eiipToken: Cookies.get(this.sysConfig.accessTokenCookieName),
        userInfo: this.userInfo,
        locale: this.$store.getters.locale,
        appMenu: this.$store.state.app.appMenu,
        firstMenu: this.appMenu.length > 0 && this.firstMenu,
        appDepthMenu: this.$store.state.app.appDepthMenu,
        appName: this.routeMeta.name,
        appUrl: this.url,
        // 是否需要刷新
        refresh: true
      })
    },

    /**
     * 子应用加载完成
     * @returns {void}
     */
    mounted() {
      this.loading = false
      if (
        this.appMenu.length > 0 &&
        (this.$route.fullPath == `/${this.$route.meta.context}` ||
          this.$route.fullPath == `/${this.$route.meta.context}/`)
      ) {
        microApp.router.push({
          name: this.$route.meta.context,
          path: `/${this.$route.meta.context}/${this.firstMenu.url}`,
          replace: true
        })
      } else if (this.appMenu.length == 0) {
        microApp.router.push({
          name: this.$route.meta.context,
          path: `/${this.$route.meta.context}/`,
          replace: true
        })
      } else if (this.appMenu.length > 0) {
        microApp.router.push({
          name: this.$route.meta.context,
          path: this.$route.fullPath,
          replace: false
        })
      }
    },

    /**
     * 子应用卸载完成
     * @returns {void}
     */
    unmount() {
      console.log(this.name, 'unmount')
      console.log('unmount stack:', new Error().stack)
      // 添加这行
    },

    /**
     * 子应用加载出错
     * @returns {void}
     */
    error() {
      console.log(this.name, 'error')
      this.loading = false
    },

    /**
     * 获取数据
     * @returns {void}
     */
    getDataHandler() {
      // 发送对应的数据
      microApp.setData(this.name, {
        origin: 'EIIP',
        skin: this.skin,
        clientId: this.routeMeta.id,
        refreshTokenCookieName: this.sysConfig.refreshTokenCookieName,
        accessTokenCookieName: this.sysConfig.accessTokenCookieName,
        accessToken: Cookies.get(this.sysConfig.accessTokenCookieName),
        refreshToken: Cookies.get(this.sysConfig.refreshTokenCookieName),
        eiipToken: Cookies.get(this.sysConfig.accessTokenCookieName),
        userInfo: this.userInfo,
        locale: this.$store.getters.locale,
        appMenu: this.$store.state.app.appMenu,
        firstMenu: this.appMenu.length > 0 && this.firstMenu,
        appDepthMenu: this.$store.state.app.appDepthMenu,
        appName: this.routeMeta.name,
        appUrl: this.url,
        // 是否需要刷新
        refresh: true
      })
    },

    /**
     * 处理子应用发送数据
     * @param {*} e 事件对象
     * @returns {void}
     */
    handleDataChange(e) {
      // 数据
      const data = e.detail.data
      // 如果不存在事件，则直接退出
      if (!data.event) {
        return
      }
      // 处理对应的事件
      this[`${data.event}Handler`] && this[`${data.event}Handler`](data.data)
    }
  }
}
</script>

<style lang="scss">
.el-dropdown-menu__item {
  &:hover,
  &:focus {
    background-color: #edf1fb !important;
    color: #4a5ff3 !important;
  }
}
// 组件样式
$class-prefix: 'sub-app';
.#{$class-prefix} {
  // position: relative;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  flex: 1;
  margin: 0 2px 0 10px;
  position: relative;
  padding-bottom: 10px;
  &_tagBtn {
    position: absolute !important;
    right: 5px;
    top: 0;
    width: 11px;
    height: 24px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-container-header {
    height: 30px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // background-color: #f5f8fc;
    z-index: 2;
    overflow: hidden;
    padding-right: 20px;
  }
  &-container-micro {
    height: calc(100% - 30px);
    overflow: hidden;
    margin-top: 30px;
    background: #fff;
    border-radius: 0 8px 8px 8px;
    padding: 10px;
  }
  &-container-micro.empty {
    height: 100%;
    overflow: hidden;
    margin-top: 30px;
    border-radius: 8px;
    padding: 0;
    background: inherit;
  }
  &_pageTagList {
    display: flex;
    align-items: center;
    gap: 2px;
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
    &:hover {
      overflow-x: auto;
      .sub-app_pageTag {
        height: 27px !important;
      }
    }
    &::-webkit-scrollbar {
      height: 3px;
      position: relative;
      z-index: 2;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      z-index: 2;
    }
    &::-webkit-scrollbar-track {
      z-index: 2;
    }
  }
  &_pageTag.active {
    color: #4a5ff3;
    background: #ffffff;
  }
  &_pageTag {
    padding: 0 10px;
    border-radius: 4px 4px 0 0;
    font-size: 14px;
    background-image: linear-gradient(180deg, #ffffffcc 84%, #f6f6f6cc 100%);
    color: #808080;
    line-height: 30px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    &_close {
      padding: 2px;
      margin-left: 5px;
      &:hover {
        background-color: #e3eafd;
        color: #333;
        cursor: pointer;
        border-radius: 50%;
      }
    }
  }
}
.#{$class-prefix}.noLeftAside {
  margin: 0 2px 0 0;
  .sub-app-container-micro {
    margin: 0 !important;
  }
}
.sub-app-container {
  display: flex;
  width: 100%;
  height: calc(100% - 7px);
  margin-top: 6px;
}
</style>
